export const FETCH_DATA_START = "FETCH_DATA_START";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILED = "FETCH_DATA_FAILED";
export const FETCH_DATA_INIT = "FETCH_DATA_INIT";

export const UPDATE_DATA = "UPDATE_DATA";
